/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axiosInstance from './axios';
import Product, { ClothingSizeTypeStock } from 'types/models/Product';
import DetailItem from 'types/models/DetailItem';

export const getProductsByCommerce = async (commerceId: string): Promise<Product[] | []> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `/commerces/${commerceId}/products/all`,
    });
    return parseProducts(data);
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getProductsSoldByCommerce = async (
  commerceId: string,
  billingRange: number,
  localTimeZone = 'America/Argentina/Buenos_Aires',
): Promise<Product[] | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: `/billing/products/${commerceId}`,
      data: {
        billingRange,
        localTimeZone,
      },
    });
    return parseProducts(data);
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const checkProductsStock = async (detailItems: DetailItem[]): Promise<Product[] | []> => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: 'check-products-stock',
      data: {
        detailItems,
      },
    });
    return parseProducts(data);
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const parseProducts = (products: any[]): Product[] => {
  return products.map((product: any): Product => parseProduct(product));
};

export const parseProduct = (product: any): Product => {
  return {
    id: product.id,
    name: product.name,
    description: product.description,
    price: product.price,
    estimatedPreparationTime: product.estimated_preparation_time,
    stock: product.stock,
    amountSold: product.amount_sold ?? undefined,
    isClothing: product.is_clothing === 1,
    clothingSizeStocks: product.clothing_sizes_stocks ? parseClothingSizeTypeStocks(product.clothing_sizes_stocks) : [],
  };
};

const parseClothingSizeTypeStocks = (clothingSizeStocks: any[]): ClothingSizeTypeStock[] => {
  return clothingSizeStocks.map((clothingSizeStock) => ({
    id: clothingSizeStock.clothing_size_type_id,
    description: clothingSizeStock.clothing_size_type.description,
    stock: clothingSizeStock.stock,
  }));
};
